.container {
  display: flex;
}

.container input {
  border: 0;
  padding: 5px 6px;
  background-color: white;
  box-sizing: border-box;
  color: var(--main-text);
  width: 100%;
  border-right: var(--field-border) 1pt solid;
  text-transform: uppercase;
}

.icons {
  width: 23px;
}

.container svg {
  fill: currentcolor;
  margin: 0 2px;
  width: 1.4em;
  padding-top: 3px;
}

.container .valid svg {
  fill: green;
}

.container .invalid svg {
  fill: red;
}
